import { useBoolean } from 'ahooks';
import { Col, Row, Space, Typography } from 'antd';
import React, { FC } from 'react';
import { ProjectsToTemplatesDrawer } from 'components/molecules/project-actions-modal';
import { useTranslation } from 'hooks/use-translation';
import { SectionTitle, StyledButton } from './styles';

const { Text } = Typography;

export const ProjectsToTemplatesControl: FC = () => {
  const [isVisible, { setTrue: showDrawer, setFalse: hideDrawer }] =
    useBoolean(false);
  const TemplateSectionTitle = useTranslation(
    'project.settings.general_information.template.title',
  );
  const TemplateSectionContent = useTranslation(
    'project.settings.general_information.template.content',
  );

  const SaveTemplateButton = useTranslation(
    'project.settings.general_information.save_as_template',
  );

  return (
    <Row>
      <Col>
        <Space direction="vertical" size="middle">
          <SectionTitle>{TemplateSectionTitle}</SectionTitle>
          <Text>{TemplateSectionContent}</Text>
          <StyledButton size="large" type="primary" ghost onClick={showDrawer}>
            {SaveTemplateButton}
          </StyledButton>
          <ProjectsToTemplatesDrawer
            isDrawerVisible={isVisible}
            hideDrawer={hideDrawer}
          />
        </Space>
      </Col>
    </Row>
  );
};
